import { render, staticRenderFns } from "./full-list.vue?vue&type=template&id=589b77a2&scoped=true&"
import script from "./full-list.vue?vue&type=script&lang=ts&"
export * from "./full-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b77a2",
  null
  
)

export default component.exports